import React, { ReactNode } from "react"
import clsx from "clsx"
import Container from "@ecom/ui/components/Container"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"

import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import { AppLinkMui } from "@ecom/ui/components/AppLink"

import { QUESTIONS } from "./helpers"
import * as styles from "./questions.module.scss"
import { DLClickEventExtended } from "../../helpers/WatcherDL/DLEvents"
import getTextFromNode from "../../helpers/getTextFromNode"

export type QuestionsList = {
  question: string
  answer: ReactNode
}

export type QuestionsProps = {
  questionList?: QuestionsList[]
  orderNum?: string
  withButtons?: boolean
  variantStyles?: string
}

const handleClick = () => {
  pushToDataLayer({
    event: "buttonClick",
    name: "Участвовать",
    placement: "qustions_button_halva",
  })
}

export const Questions = ({
  questionList = QUESTIONS,
  orderNum,
  withButtons = false,
  variantStyles,
}: QuestionsProps) => {
  const [expanded, setExpanded] = React.useState<string | false>(QUESTIONS[0].question || false)

  const handleChange = (panel: string) => (_: any, isExpanded: boolean) => {
    DLClickEventExtended({
      name: getTextFromNode(panel).slice(0, 30),
      eventAction: "Вопросы и ответы",
      placement: "faq",
    })

    setExpanded(isExpanded ? panel : false)
  }

  return (
    <section
      className={clsx(styles.section, variantStyles && styles[variantStyles])}
      id="questions"
      data-exclude={orderNum}
    >
      <Container>
        <h3 className={styles.title}>Вопросы и ответы</h3>
        {questionList?.map((q) => (
          <Accordion
            key={q.question}
            onChange={handleChange(q.question)}
            expanded={expanded === q.question}
            classes={{
              root: styles.accordion_root,
              expanded: styles.accordion_root_expanded,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              classes={{
                root: styles.summary_root,
                expandIcon: styles.expand_icon,
                content: styles.summary_content,
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: q.question }} />
            </AccordionSummary>
            <AccordionDetails
              classes={{
                root: styles.details_root,
              }}
            >
              <div className={styles.answers}>{q.answer}</div>
            </AccordionDetails>
          </Accordion>
        ))}
        {withButtons && (
          <div className={styles.withButtons}>
            <AppLinkMui
              href="https://halvacard.ru/shops/actions/otkryvaem-shubohranilishe"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.btn}
              underline="none"
              onClick={handleClick}
            >
              Участвовать
            </AppLinkMui>
          </div>
        )}
      </Container>
    </section>
  )
}
